import React, { Fragment } from 'react';
import Query from 'apps/hiring/util/query';
import PropTypes from 'prop-types';
import { Switch, Route, Link } from 'library/util/core-router';
import withData from 'util/hoc/with-data';
import { resolve } from 'library/helpers/path-resolver';
import { ShimmyValue } from 'library/components/shimmy';
import HiringQuery from 'apps/hiring/util/query';
import { jsonToInputParams } from 'library/util/graph';
import EvaluateLoading from 'apps/hiring/components/loading/evaluate';
import SubscriptionInviteModal from 'library/components/employee-select-modal';
import withUser from 'util/hoc/with-user';

import EmployeeCharts from 'apps/hiring/components/employee/employee-charts';
import EmployeeSurvey from 'apps/hiring/components/employee/employee-survey';
import EmployeeNavigation from 'apps/hiring/components/employee/employee-navigation';
import EmployeeMeasure from 'apps/hiring/components/employee/employee-measure';
import EmployeeSettings from 'apps/hiring/components/employee/employee-settings';

const AddEmployees = (props) => (
  <button {...props}> Add Employees </button>
);

class Group extends React.Component {
  state = {
    target: null,
    query: (`
      {
        group (id: ${this.props.match.params.id}) {
          id,
          name,
          archived,
            users(limit: 1000, has_surveyed: true) {
              results {
                first_name,
                last_name,
                id,
                assessment(completed: true) {
                  id
                  validity_score
                  validity_errors
                  scored
                }
            }
          }
      }
    }
    `)
  }

  setTarget = (target) => {
    if(!target) return;

    let selectedTargetId = target;
    if (typeof selectedTargetId == 'object') selectedTargetId = target.id;

    this.setState({
      query: (`
        {
          group (id: ${this.props.match.params.id}) {
            id,
            name,
            archived,
            users(limit: 1000, has_surveyed: true) {
              results {
                first_name,
                last_name,
                id,
                ${this.PossibleMatch(selectedTargetId)}
                assessment(completed: true) {
                  id
                  validity_score
                  validity_errors
                  scored
            }
          }
        }
      }
    }
        `),
      target: selectedTargetId
    });
  }

  handleAddEmployees = async (users, type='Employee') => {
    if (!users) return;

    for (const user of users){
      const params = {
        node_id: Number(resolve(this.props, 'match/params/id', null)),
        user_id: Number(user.id),
        user_type: type
      };

      try {
        await HiringQuery(`
          mutation {
            add_user_to_node(${jsonToInputParams(params)}){
              success,
              errors
            }
          }
          `);
      } catch (e) {
        console.error(e);
      }
    }

    this.props.reload_graph(true);
  }

  addTarget = async (targets) => {
    if (!targets) return;

    const params = {
      ids: targets.map(t=>t.id),
      connectable_id: Number(resolve(this.props, 'match/params/id', null)),
      connectable_type: 'node'
    };

    try {
      await HiringQuery(`
      mutation {
        connect_targets (${jsonToInputParams(params)}) {
          success,
          errors,
          target_groupings {
              name,
              finalized,
              id
            }
        }
      }
    `);

      await this.props.reload_graph(true, true);

      this.setTarget(resolve(targets, '0/id', null));
    } catch (e) {
      console.error(e);
    }
  }

  PossibleMatch = (target) => {
    if (target !== null) {
      return `match(target_id:${Number(target)}),`;
    }
    return '';
  }

  render() {
    const {
      match,
      graph_loading,
      graph_data,
      reload_graph,
      user
    } = this.props;

    const { query } = this.state

    if (graph_loading) {
      return (
        <div className="hiring-evaluate">
          <EvaluateLoading />
        </div>
      );
    }

    return (
      <Fragment>
        <ShimmyValue namespace="hiring-breadcrumbs">
          <Link to="/hiring/employees" key="application">People</Link>
          <span key="opening">{resolve(graph_data, 'group/name', '')}</span>
        </ShimmyValue>
        <div className="hiring-body">
          <Route
            path={`/hiring/groups/${match.params.id}`}
            component={(params) => <EmployeeNavigation {...params} type='groups' id={match.params.id}/>}
          />
          { graph_loading ?
            <div className="hiring-evaluate">
              <EvaluateLoading />
            </div>
            :
            graph_data.users.length == 0 ?
              <div style={{height:'auto'}} className="hiring-evaluate-cta">
                <h1>
                  No Employees within {graph_data.group.name}
                </h1>
                <SubscriptionInviteModal
                  addType='Employee'
                  handleSumbit={this.handleAddEmployees}
                  buttonText='Add'
                  title={'Add Employee'}
                  component={AddEmployees}
                />
              </div>
              :
              <section className="hiring-section">
                <Switch>
                  <Route path="/hiring/groups/:id/surveys"
                    render={(params) =>
                      (<EmployeeSurvey
                        graph_loading={graph_loading}
                        stats={graph_data.stats}
                        users={graph_data.users}
                        pagination={graph_data.pagination}
                        {...params}
                      />)}
                  />

                  <Route path="/hiring/groups/:id/evaluate">
                    <EmployeeMeasure
                      type={'group'}
                      setTarget={this.setTarget}
                      target={this.state.target}
                      query={query}
                      name={resolve(graph_data, 'group/name', 'Group')}
                      targets={graph_data.targets}
                      match={this.props.match}
                      addTarget={this.addTarget}
                      reload_graph={reload_graph}
                    />
                  </Route>

                  <Route path="/hiring/groups/:id/charts"
                    render={(params) => (
                      <EmployeeCharts
                        users={graph_data.completed_assessments_users}
                        match={this.props.match}
                        graph_loading={graph_loading}
                        assessments={graph_data.completed_assessments_chart}
                        {...params}
                      />
                    )}
                  />

                  <Route path="/hiring/groups/:id/settings"
                    render={(props)=>(
                      <EmployeeSettings
                        managers={graph_data.managers}
                        type={'Group'}
                        type_data={graph_data.group}
                        targets={graph_data.targets}
                        disabled={false}
                        reload={reload_graph}
                        addTarget={this.addTarget}
                        users={graph_data.users}
                        addUsers={this.handleAddEmployees}
                        user={user.id}
                        {...props}
                      />
                    )}
                  />

                </Switch>
              </section>
          }
        </div>
      </Fragment>
    );
  }
}

Group.propTypes = {
  match: PropTypes.object,
  graph_loading: PropTypes.bool,
  graph_data: PropTypes.object,
  reload_graph: PropTypes.func,
  user: PropTypes.object
};


Group.parseQueryData = (data) => ({
  stats: resolve(data, 'group/assessment_stats', {}),
  users: resolve(data, 'group/users/results', []),
  managers: resolve(data, 'group/managers/results', []),
  completed_assessments_users: resolve(data, 'group/completed_assessments/results', []),
  pagination: resolve(data, 'group/users/pagination', {}),
  group: resolve(data, 'group', {}),
  targets: resolve(data, 'group/target_groupings/results', []),
  completed_assessments_chart: [{
    title: 'employees',
    color: 'pink',
    ids: resolve(data, 'group/completed_assessments/results', []).map(e=>e.assessment.id)
  }]
});

Group.query = (token, { match }) => (
  Query(`
    {
      group (id: ${match.params.id}) {
        managers {
          results {
            name
            id
            first_name
            last_name
            email
          }
        }
        id,
         name,
         archived,
         users(limit: 100) {
           pagination {
             limit
             offset
             total
           }
           results {,
             name
             id
             first_name
             last_name,
             email
             assessment {
               id
               progress
               completion_date
               scored
             }
           }
         }
         completed_assessments: users(limit: 1000, has_surveyed: true) {
           results {
             first_name,
             last_name,
             id,
             email,
             assessment(completed: true) {
               id
               validity_score
               validity_errors
               scored
             }
           }
         }
         assessment_stats {
           complete
           ideal
           incomplete
           invalid
           real
           scored
           valid
         }
        target_groupings (limit: 100) {
         pagination {
           limit,
           offset,
           total
         }
         results {
           id,
           name,
           finalized,
           description,
           targets {
             id
             characteristic {
               description,
               name
             }
             percentile_range {
               end,
               start
             }
           }
         }
       }
   }
   }
  `)
);

export default withUser(withData(Group));
